export default "__VITE_ASSET__CaxhSY84__"